import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/university")({
  component: UniversityLayout,
});

function UniversityLayout() {
  return <Outlet />;
}
